import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { fetchTransactionDetail } from '../../../redux/actions/transactionDetailActions';
import PaymentSection from './PaymentSection';

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      fetchTransactionDetail: fetchTransactionDetail.request,
    },
    dispatch
  );
};

export default connect(undefined, mapDispatchToProps)(PaymentSection);
